window.Vue = require('vue');

window.events = new Vue();

require('./vendor');

require('./plugins');

require('./directives');

require('./components');

// Инициализация экземпляра Vue приложения на странице.
const app = new Vue({
    el: "#app",
    comments: true,
});
